// extracted by mini-css-extract-plugin
export var notificationHost = "_mf-0";